@if (list?.length) {
  <table
    class="tooltip-container">
    @for (item of list; track item) {
      <tr>
        <td class="cs-key-value-list--key">{{item.key}}:</td>
        <td class="cs-key-value-list--value">{{item.value}}</td>
      </tr>
    }
  </table>
}
